import React, {Component} from 'react';
import * as Yup from 'yup';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import {FormField} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import {RouteComponentProps} from "react-router";
import {IBrandsStore} from "../../mobx-store/storeInterfaces/brandsStoreInterface";
import {inject, observer} from "mobx-react";
import {Button, Typography} from "@material-ui/core";
import AlertDialog from "../../components/Dialog/alertDialog";


interface IProps {
    brandsStore: IBrandsStore;
}
interface IState {
    formFields: FormField[];
    processing: boolean;
    loading: boolean;
    isDialogOpen: boolean;
}

@inject('brandsStore')
@observer
class AddEditBrand extends Component<IProps & RouteComponentProps<{
    brandId: string
}>,IState> {
    isNew: boolean = false;
    submitButton: any;
    cancelButton: any;
    TeamSchema: any;
    brandId: any;
    pageTitle = '';

    constructor(props: IProps& RouteComponentProps<{
        brandId: string
    }>) {
        super(props);
        if (this.props.match.params.brandId) {
            this.isNew = false;
            this.brandId = this.props.match.params.brandId;
            this.pageTitle = 'Edit Brand';
        } else {
            this.isNew = true;
            this.pageTitle = 'Add Brand';
        }
        this.initTeamSchema();
        this.initState();
        this.submitButton = this.getSubmitButton();
        this.cancelButton = this.getCancelButton();
    }

    initTeamSchema = () => {
        this.TeamSchema = Yup.object().shape({
            brandName: Yup.string().required('Required'),
        });
    };

    getSubmitButton = () => {
        return {
            title: (this.isNew ? 'Add' : 'Save Changes'),
            onSubmit: this.handelSubmit,
        };
    }

    getCancelButton = () => {
        return {
            title: 'Cancel',
            onCancel: this.navigateBack,
        };
    }

    navigateBack = () => {
        this.props.history.goBack();
    }

    handelSubmit = async (values: any) => {
        this.setState({processing: true});
        if (this.isNew) {
            await this.props.brandsStore.addBrand(values);
        } else {
            await this.props.brandsStore.editBrand(this.brandId,values);
        }
        this.navigateBack();
        this.setState({processing: false});
    };
    initState = () => {
        this.state = {
            isDialogOpen: false,
            processing: false,
            loading: false,
            formFields: [
                {
                    name: 'brandName',
                    label: 'Brand Name',
                    type: 'text',
                    filedType: 'InputField',
                },
            ]
        };
    }
    updateStateWithTeamData = (currentBrand: any) => {
        const formFieldsWithData = [];
        for (let field of this.state.formFields) {
            formFieldsWithData.push(Object.assign({}, field, {value: currentBrand[field.name]}));
        }
        this.setState({formFields: formFieldsWithData, processing: false ,  loading: false});
    }
    async componentDidMount() {
        if (!this.isNew) {
            this.setState({loading: true});
            await this.props.brandsStore.getBrandById(this.brandId).then(snapshot => {
                this.updateStateWithTeamData(snapshot.val());
            }).catch(() => {
                this.setState({loading: false});
            });

        }
    }
    handleDelete = async () => {
        this.setState({isDialogOpen: true});
    }
    handleAgree = async () => {
        await this.props.brandsStore.deleteBrand(this.brandId);
        this.navigateBack();
    }
    handleClose = () => {
        this.setState({isDialogOpen: false});
    }
    render() {
        return (
            <div>
                {this.state.loading ?
                    <Typography variant='h6' gutterBottom>Loading</Typography>
                    : <GeneralFormComponent
                        formTitle={this.pageTitle}
                        fields={this.state.formFields}
                        formSchema={this.TeamSchema}
                        submitButton={this.submitButton}
                        cancelButton={this.cancelButton}
                        processing={this.state.processing}
                    />
                }
                {/*{*/}
                {/*    this.isNew ? null : <Button*/}
                {/*        onClick={this.handleDelete}*/}
                {/*        variant='contained'*/}
                {/*        type='button'*/}
                {/*        style={{fontSize: '14px',fontWeight:'bold'}}*/}
                {/*        color='secondary'>*/}
                {/*        Delete*/}
                {/*    </Button>*/}
                {/*}*/}
                {
                    <AlertDialog isOpen={this.state.isDialogOpen}
                                 title='Delete Brand'
                                 content='Are You Sure You want to Delete This Brand ?'
                                 buttonText='ok'
                                 agree={this.handleAgree}
                                 disAgree={this.handleClose}
                                 hasActions={true}
                    />
                }
            </div>
        );
    }
}

export default AddEditBrand;